import { VALIDATION_VARIANTS } from '@gef-ui/material-theme-utils';
import { formHelperTextClasses } from '@mui/material/FormHelperText';
export default function FormHelperText(theme) {
    return {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: '2px',
                    variants: [
                        {
                            props: {
                                compact: true
                            },
                            style: {
                                [`&.${formHelperTextClasses.root}`]: {
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }
                            }
                        },
                        ...VALIDATION_VARIANTS.map((variant)=>({
                                props: {
                                    validation: variant
                                },
                                style: {
                                    color: theme.palette[variant].main,
                                    [`&.${formHelperTextClasses.disabled}`]: {
                                        color: theme.palette[variant].main
                                    }
                                }
                            }))
                    ]
                }
            }
        }
    };
}
